(() => {
  // The drawer shows one express button: Apple Pay where the device supports it, otherwise
  // Google Pay. Shop Pay adds nothing over Secure Checkout. Shopify lays out its express
  // buttons from the wallet-configs attribute when the element first renders, so hiding the
  // extras with CSS leaves the survivor in a part-width column. Rebuilding the element with
  // only the chosen wallet gives one full-width button.
  const canUseApplePay = () => {
    try {
      return Boolean(window.ApplePaySession && window.ApplePaySession.canMakePayments());
    } catch (error) {
      return false;
    }
  };

  const chooseWallet = (configs) => {
    const names = configs.map((config) => config.name);
    if (names.includes('apple_pay') && canUseApplePay()) return 'apple_pay';
    if (names.includes('google_pay')) return 'google_pay';
    return names.find((name) => name !== 'shop_pay' && name !== 'apple_pay');
  };

  const tidy = (drawer) => {
    drawer.querySelectorAll('.mori-cart__express shopify-accelerated-checkout-cart').forEach((element) => {
      let configs;
      try {
        configs = JSON.parse(element.getAttribute('wallet-configs') || '[]');
      } catch (error) {
        return;
      }

      const chosen = chooseWallet(configs);
      if (!chosen) return;
      const kept = configs.filter((config) => config.name === chosen);
      if (kept.length === configs.length) return;

      const rebuilt = element.cloneNode(false);
      rebuilt.setAttribute('wallet-configs', JSON.stringify(kept));
      element.replaceWith(rebuilt);
    });
  };

  const start = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    tidy(drawer);
    // The drawer re-renders its footer after every cart change
    new MutationObserver(() => tidy(drawer)).observe(drawer, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
